var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-dialog"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticStyle:{"line-height":"30px"}},[_vm._v("您当前未完成平台认证审核，认证后即可发布岗位、查看学生投递简历！")]),_c('div',{staticClass:"btn-wrap"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.$router.push('/pay')}}},[_vm._v("马上去认证")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }